import type { NavigationGuard } from "vue-router";
import { RouteNames } from "@shared/types/localTypes/router.ts";
import { useKeycloakStore } from "@shared/stores/keycloak.ts";
import logger from "@shared/utils/logger.ts";

const IDP_ALIAS_MAX_LENGTH = 107;
const IDP_ALIAS_PATTERN =
  /^saml-1-((?!(.*\.)?sso\.jfrog\.io$)([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z0-9]+(-[a-z0-9]+)*|[0-9a-f]{12}\.sso\.jfrog\.io)$/;

export const idpLogin: NavigationGuard = async (to) => {
  const idpHint = to.query.kc_idp_hint;
  if (
    typeof idpHint !== "string" ||
    idpHint.length > IDP_ALIAS_MAX_LENGTH ||
    !IDP_ALIAS_PATTERN.test(idpHint)
  ) {
    logger.error("IdP login is missing a valid kc_idp_hint");
    return { name: RouteNames.Login };
  }

  const keycloakStore = useKeycloakStore();
  await keycloakStore.initializeKeycloak();
  const keycloak = keycloakStore.keycloak;
  if (!keycloak) {
    logger.error("IdP login could not reach Keycloak");
    return { name: RouteNames.Login };
  }

  if (keycloak.authenticated) {
    return { name: RouteNames.Root };
  }

  const loginUrl = await keycloak.createLoginUrl({
    idpHint,
    redirectUri: `${window.location.origin}/login`,
  });
  window.location.assign(loginUrl);
  return false;
};
